import { ADD_APPOINTMENT_LOCATION_TYPE, ADD_APPOINTMENT_LOCATION_TYPE_ERROR, ADD_APPOINTMENT_LOCATION_TYPE_SUCCESS, ADD_APPOINTMENT_PRIORITY, ADD_APPOINTMENT_PRIORITY_ERROR, ADD_APPOINTMENT_PRIORITY_SUCCESS, ADD_APPOINTMENT_TYPE, ADD_APPOINTMENT_TYPE_ERROR, ADD_APPOINTMENT_TYPE_SUCCESS, ADD_CAMPAIGN_EMAIL_LIST, ADD_CAMPAIGN_EMAIL_LIST_ERROR, ADD_CAMPAIGN_EMAIL_LIST_SUCCESS, ADD_CONTACT_LEVEL, ADD_CONTACT_LEVEL_ERROR, ADD_CONTACT_LEVEL_SUCCESS, ADD_CONTACT_STATUS, ADD_CONTACT_STATUS_ERROR, ADD_CONTACT_STATUS_SUCCESS, ADD_CONTACT_TYPE, ADD_CONTACT_TYPE_ERROR, ADD_CONTACT_TYPE_SUCCESS, ADD_EMAIL_LIST_TARGET, ADD_EMAIL_LIST_TARGET_ERROR, ADD_EMAIL_LIST_TARGET_SUCCESS, ADD_EMAIL_LIST_TYPE, ADD_EMAIL_LIST_TYPE_ERROR, ADD_EMAIL_LIST_TYPE_SUCCESS, ADD_LEAD_CLASSIFICATION, ADD_LEAD_CLASSIFICATION_ERROR, ADD_LEAD_CLASSIFICATION_SUCCESS, ADD_LEAD_SOURCE, ADD_LEAD_SOURCE_ERROR, ADD_LEAD_SOURCE_SUCCESS, ADD_LEAD_STAGE, ADD_LEAD_STAGE_ERROR, ADD_LEAD_STAGE_SUCCESS, ADD_LEAD_STATUS, ADD_LEAD_STATUS_ERROR, ADD_LEAD_STATUS_SUCCESS, ADD_LEAD_TYPE, ADD_LEAD_TYPE_ERROR, ADD_LEAD_TYPE_SUCCESS, ADD_LISTING_STATUS, ADD_LISTING_STATUS_ERROR, ADD_LISTING_STATUS_SUCCESS, ADD_LISTING_TYPE, ADD_LISTING_TYPE_ERROR, ADD_LISTING_TYPE_SUCCESS, ADD_NOTE_TYPE, ADD_NOTE_TYPE_ERROR, ADD_NOTE_TYPE_SUCCESS, ADD_PROJECT_DOCUMENT_TYPE, ADD_PROJECT_DOCUMENT_TYPE_ERROR, ADD_PROJECT_DOCUMENT_TYPE_SUCCESS, ADD_PROJECT_STATUS, ADD_PROJECT_STATUS_ERROR, ADD_PROJECT_STATUS_SUCCESS, ADD_PROJECT_TYPE, ADD_PROJECT_TYPE_ERROR, ADD_PROJECT_TYPE_SUCCESS, ADD_SERVICE_TYPE, ADD_SERVICE_TYPE_ERROR, ADD_SERVICE_TYPE_SUCCESS, ADD_SHOWING_STATUS, ADD_SHOWING_STATUS_ERROR, ADD_SHOWING_STATUS_SUCCESS, ADD_TASK_PRIORITY, ADD_TASK_PRIORITY_ERROR, ADD_TASK_PRIORITY_SUCCESS, ADD_TASK_REMINDER, ADD_TASK_REMINDER_ERROR, ADD_TASK_REMINDER_SUCCESS, ADD_TASK_STATUS, ADD_TASK_STATUS_ERROR, ADD_TASK_STATUS_SUCCESS, ADD_TASK_TYPE, ADD_TASK_TYPE_ERROR, ADD_TASK_TYPE_SUCCESS, ADD_TRANSACTION_COMMISSION_TYPE, ADD_TRANSACTION_COMMISSION_TYPE_ERROR, ADD_TRANSACTION_COMMISSION_TYPE_SUCCESS, ADD_TRANSACTION_REF_TYPE, ADD_TRANSACTION_REF_TYPE_ERROR, ADD_TRANSACTION_REF_TYPE_SUCCESS, ADD_TRANSACTION_STATUS_TYPE, ADD_TRANSACTION_STATUS_TYPE_ERROR, ADD_TRANSACTION_STATUS_TYPE_SUCCESS, ADD_TRANSACTION_TYPE, ADD_TRANSACTION_TYPE_ERROR, ADD_TRANSACTION_TYPE_SUCCESS, DELETE_APPOINTMENT_LOCATION_TYPE, DELETE_APPOINTMENT_LOCATION_TYPE_ERROR, DELETE_APPOINTMENT_LOCATION_TYPE_SUCCESS, DELETE_APPOINTMENT_PRIORITY, DELETE_APPOINTMENT_PRIORITY_ERROR, DELETE_APPOINTMENT_PRIORITY_SUCCESS, DELETE_APPOINTMENT_TYPE, DELETE_APPOINTMENT_TYPE_ERROR, DELETE_APPOINTMENT_TYPE_SUCCESS, DELETE_CAMPAIGN_EMAIL_LIST, DELETE_CAMPAIGN_EMAIL_LIST_ERROR, DELETE_CAMPAIGN_EMAIL_LIST_SUCCESS, DELETE_CONTACT_LEVEL, DELETE_CONTACT_LEVEL_ERROR, DELETE_CONTACT_LEVEL_SUCCESS, DELETE_CONTACT_STATUS, DELETE_CONTACT_STATUS_ERROR, DELETE_CONTACT_STATUS_SUCCESS, DELETE_CONTACT_TYPE, DELETE_CONTACT_TYPE_ERROR, DELETE_CONTACT_TYPE_SUCCESS, DELETE_EMAIL_LIST_TARGET, DELETE_EMAIL_LIST_TARGET_ERROR, DELETE_EMAIL_LIST_TARGET_SUCCESS, DELETE_EMAIL_LIST_TYPE, DELETE_EMAIL_LIST_TYPE_ERROR, DELETE_EMAIL_LIST_TYPE_SUCCESS, DELETE_LEAD_CLASSIFICATION, DELETE_LEAD_CLASSIFICATION_ERROR, DELETE_LEAD_CLASSIFICATION_SUCCESS, DELETE_LEAD_SOURCE, DELETE_LEAD_SOURCE_ERROR, DELETE_LEAD_SOURCE_SUCCESS, DELETE_LEAD_STAGE, DELETE_LEAD_STAGE_ERROR, DELETE_LEAD_STAGE_SUCCESS, DELETE_LEAD_STATUS, DELETE_LEAD_STATUS_ERROR, DELETE_LEAD_STATUS_SUCCESS, DELETE_LEAD_TYPE, DELETE_LEAD_TYPE_ERROR, DELETE_LEAD_TYPE_SUCCESS, DELETE_LISTING_STATUS, DELETE_LISTING_STATUS_ERROR, DELETE_LISTING_STATUS_SUCCESS, DELETE_LISTING_TYPE, DELETE_LISTING_TYPE_ERROR, DELETE_LISTING_TYPE_SUCCESS, DELETE_NOTE_TYPE, DELETE_NOTE_TYPE_ERROR, DELETE_NOTE_TYPE_SUCCESS, DELETE_PROJECT_DOCUMENT_TYPE, DELETE_PROJECT_DOCUMENT_TYPE_ERROR, DELETE_PROJECT_DOCUMENT_TYPE_SUCCESS, DELETE_PROJECT_STATUS, DELETE_PROJECT_STATUS_ERROR, DELETE_PROJECT_STATUS_SUCCESS, DELETE_PROJECT_TYPE, DELETE_PROJECT_TYPE_ERROR, DELETE_PROJECT_TYPE_SUCCESS, DELETE_SERVICE_TYPE, DELETE_SERVICE_TYPE_ERROR, DELETE_SERVICE_TYPE_SUCCESS, DELETE_SHOWING_STATUS, DELETE_SHOWING_STATUS_ERROR, DELETE_SHOWING_STATUS_SUCCESS, DELETE_TASK_PRIORITY, DELETE_TASK_PRIORITY_ERROR, DELETE_TASK_PRIORITY_SUCCESS, DELETE_TASK_REMINDER, DELETE_TASK_REMINDER_ERROR, DELETE_TASK_REMINDER_SUCCESS, DELETE_TASK_STATUS, DELETE_TASK_STATUS_ERROR, DELETE_TASK_STATUS_SUCCESS, DELETE_TASK_TYPE, DELETE_TASK_TYPE_ERROR, DELETE_TASK_TYPE_SUCCESS, DELETE_TRANSACTION_COMMISSION_TYPE, DELETE_TRANSACTION_COMMISSION_TYPE_ERROR, DELETE_TRANSACTION_COMMISSION_TYPE_SUCCESS, DELETE_TRANSACTION_REF_TYPE, DELETE_TRANSACTION_REF_TYPE_ERROR, DELETE_TRANSACTION_REF_TYPE_SUCCESS, DELETE_TRANSACTION_STATUS_TYPE, DELETE_TRANSACTION_STATUS_TYPE_ERROR, DELETE_TRANSACTION_STATUS_TYPE_SUCCESS, DELETE_TRANSACTION_TYPE, DELETE_TRANSACTION_TYPE_ERROR, DELETE_TRANSACTION_TYPE_SUCCESS, GET_APPOINTMENT_LOCATION_TYPE, GET_APPOINTMENT_LOCATION_TYPE_FAIL, GET_APPOINTMENT_LOCATION_TYPE_SUCCESS, GET_APPOINTMENT_PRIORITY, GET_APPOINTMENT_PRIORITY_FAIL, GET_APPOINTMENT_PRIORITY_SUCCESS, GET_APPOINTMENT_TYPE, GET_APPOINTMENT_TYPE_FAIL, GET_APPOINTMENT_TYPE_SUCCESS, GET_CAMPAIGN_EMAIL_LIST, GET_CAMPAIGN_EMAIL_LIST_ERROR, GET_CAMPAIGN_EMAIL_LIST_SUCCESS, GET_CONTACT_LEVEL, GET_CONTACT_LEVEL_FAIL, GET_CONTACT_LEVEL_SUCCESS, GET_CONTACT_STATUS, GET_CONTACT_STATUS_FAIL, GET_CONTACT_STATUS_SUCCESS, GET_CONTACT_TYPE, GET_CONTACT_TYPE_FAIL, GET_CONTACT_TYPE_SUCCESS, GET_EMAIL_LIST_TARGET, GET_EMAIL_LIST_TARGET_ERROR, GET_EMAIL_LIST_TARGET_SUCCESS, GET_EMAIL_LIST_TYPE, GET_EMAIL_LIST_TYPE_ERROR, GET_EMAIL_LIST_TYPE_SUCCESS, GET_LEAD_CLASSIFICATION, GET_LEAD_CLASSIFICATION_FAIL, GET_LEAD_CLASSIFICATION_SUCCESS, GET_LEAD_SOURCE, GET_LEAD_SOURCE_FAIL, GET_LEAD_SOURCE_SUCCESS, GET_LEAD_STAGE, GET_LEAD_STAGE_FAIL, GET_LEAD_STAGE_SUCCESS, GET_LEAD_STATUS, GET_LEAD_STATUS_FAIL, GET_LEAD_STATUS_SUCCESS, GET_LEAD_TYPE, GET_LEAD_TYPE_FAIL, GET_LEAD_TYPE_SUCCESS, GET_LISTING_STATUS, GET_LISTING_STATUS_ERROR, GET_LISTING_STATUS_SUCCESS, GET_LISTING_TYPE, GET_LISTING_TYPE_FAIL, GET_LISTING_TYPE_SUCCESS, GET_NOTE_TYPE, GET_NOTE_TYPE_FAIL, GET_NOTE_TYPE_SUCCESS, GET_PROJECT_DOCUMENT_TYPE, GET_PROJECT_DOCUMENT_TYPE_FAIL, GET_PROJECT_DOCUMENT_TYPE_SUCCESS, GET_PROJECT_STATUS, GET_PROJECT_STATUS_FAIL, GET_PROJECT_STATUS_SUCCESS, GET_PROJECT_TYPE, GET_PROJECT_TYPE_FAIL, GET_PROJECT_TYPE_SUCCESS, GET_SERVICE_TYPE, GET_SERVICE_TYPE_FAIL, GET_SERVICE_TYPE_SUCCESS, GET_SHOWING_STATUS, GET_SHOWING_STATUS_ERROR, GET_SHOWING_STATUS_SUCCESS, GET_TASK_PRIORITY, GET_TASK_PRIORITY_FAIL, GET_TASK_PRIORITY_SUCCESS, GET_TASK_REMINDER, GET_TASK_REMINDER_FAIL, GET_TASK_REMINDER_SUCCESS, GET_TASK_STATUS, GET_TASK_STATUS_FAIL, GET_TASK_STATUS_SUCCESS, GET_TASK_TYPE, GET_TASK_TYPE_FAIL, GET_TASK_TYPE_SUCCESS, GET_TRANSACTION_COMMISSION_TYPE, GET_TRANSACTION_COMMISSION_TYPE_FAIL, GET_TRANSACTION_COMMISSION_TYPE_SUCCESS, GET_TRANSACTION_REF_TYPE, GET_TRANSACTION_REF_TYPE_FAIL, GET_TRANSACTION_REF_TYPE_SUCCESS, GET_TRANSACTION_STATUS_TYPE, GET_TRANSACTION_STATUS_TYPE_FAIL, GET_TRANSACTION_STATUS_TYPE_SUCCESS, GET_TRANSACTION_TYPE, GET_TRANSACTION_TYPE_FAIL, GET_TRANSACTION_TYPE_SUCCESS, UPDATE_APPOINTMENT_LOCATION_TYPE, UPDATE_APPOINTMENT_LOCATION_TYPE_FAIL, UPDATE_APPOINTMENT_LOCATION_TYPE_SUCCESS, UPDATE_APPOINTMENT_PRIORITY, UPDATE_APPOINTMENT_PRIORITY_FAIL, UPDATE_APPOINTMENT_PRIORITY_SUCCESS, UPDATE_APPOINTMENT_TYPE, UPDATE_APPOINTMENT_TYPE_FAIL, UPDATE_APPOINTMENT_TYPE_SUCCESS, UPDATE_CAMPAIGN_EMAIL_LIST, UPDATE_CAMPAIGN_EMAIL_LIST_ERROR, UPDATE_CAMPAIGN_EMAIL_LIST_SUCCESS, UPDATE_CONTACT_LEVEL, UPDATE_CONTACT_LEVEL_FAIL, UPDATE_CONTACT_LEVEL_SUCCESS, UPDATE_CONTACT_STATUS, UPDATE_CONTACT_STATUS_FAIL, UPDATE_CONTACT_STATUS_SUCCESS, UPDATE_CONTACT_TYPE, UPDATE_CONTACT_TYPE_FAIL, UPDATE_CONTACT_TYPE_SUCCESS, UPDATE_EMAIL_LIST_TARGET, UPDATE_EMAIL_LIST_TARGET_ERROR, UPDATE_EMAIL_LIST_TARGET_SUCCESS, UPDATE_EMAIL_LIST_TYPE, UPDATE_EMAIL_LIST_TYPE_ERROR, UPDATE_EMAIL_LIST_TYPE_SUCCESS, UPDATE_LEAD_CLASSIFICATION, UPDATE_LEAD_CLASSIFICATION_FAIL, UPDATE_LEAD_CLASSIFICATION_SUCCESS, UPDATE_LEAD_SOURCE, UPDATE_LEAD_SOURCE_FAIL, UPDATE_LEAD_SOURCE_SUCCESS, UPDATE_LEAD_STAGE, UPDATE_LEAD_STAGE_FAIL, UPDATE_LEAD_STAGE_SUCCESS, UPDATE_LEAD_STATUS, UPDATE_LEAD_STATUS_FAIL, UPDATE_LEAD_STATUS_SUCCESS, UPDATE_LEAD_TYPE, UPDATE_LEAD_TYPE_FAIL, UPDATE_LEAD_TYPE_SUCCESS, UPDATE_LISTING_STATUS, UPDATE_LISTING_STATUS_ERROR, UPDATE_LISTING_STATUS_SUCCESS, UPDATE_LISTING_TYPE, UPDATE_LISTING_TYPE_FAIL, UPDATE_LISTING_TYPE_SUCCESS, UPDATE_NOTE_TYPE, UPDATE_NOTE_TYPE_FAIL, UPDATE_NOTE_TYPE_SUCCESS, UPDATE_PROJECT_DOCUMENT_TYPE, UPDATE_PROJECT_DOCUMENT_TYPE_FAIL, UPDATE_PROJECT_DOCUMENT_TYPE_SUCCESS, UPDATE_PROJECT_STATUS, UPDATE_PROJECT_STATUS_FAIL, UPDATE_PROJECT_STATUS_SUCCESS, UPDATE_PROJECT_TYPE, UPDATE_PROJECT_TYPE_FAIL, UPDATE_PROJECT_TYPE_SUCCESS, UPDATE_SERVICE_TYPE, UPDATE_SERVICE_TYPE_FAIL, UPDATE_SERVICE_TYPE_SUCCESS, UPDATE_SHOWING_STATUS, UPDATE_SHOWING_STATUS_ERROR, UPDATE_SHOWING_STATUS_SUCCESS, UPDATE_TASK_PRIORITY, UPDATE_TASK_PRIORITY_FAIL, UPDATE_TASK_PRIORITY_SUCCESS, UPDATE_TASK_REMINDER, UPDATE_TASK_REMINDER_FAIL, UPDATE_TASK_REMINDER_SUCCESS, UPDATE_TASK_STATUS, UPDATE_TASK_STATUS_FAIL, UPDATE_TASK_STATUS_SUCCESS, UPDATE_TASK_TYPE, UPDATE_TASK_TYPE_FAIL, UPDATE_TASK_TYPE_SUCCESS, UPDATE_TRANSACTION_COMMISSION_TYPE, UPDATE_TRANSACTION_COMMISSION_TYPE_FAIL, UPDATE_TRANSACTION_COMMISSION_TYPE_SUCCESS, UPDATE_TRANSACTION_REF_TYPE, UPDATE_TRANSACTION_REF_TYPE_FAIL, UPDATE_TRANSACTION_REF_TYPE_SUCCESS, UPDATE_TRANSACTION_STATUS_TYPE, UPDATE_TRANSACTION_STATUS_TYPE_FAIL, UPDATE_TRANSACTION_STATUS_TYPE_SUCCESS, UPDATE_TRANSACTION_TYPE, UPDATE_TRANSACTION_TYPE_FAIL, UPDATE_TRANSACTION_TYPE_SUCCESS } from "./actionTypes"

export const addAppLocationType = (location, history) => {
  return {
    type: ADD_APPOINTMENT_LOCATION_TYPE,
    payload: { location, history },
  }
}

export const addAppLocationTypeSuccess = location => {
  return {
    type: ADD_APPOINTMENT_LOCATION_TYPE_SUCCESS,
    payload: location,
  }
}


export const addAppLocationTypeError = error => {
  return {
    type: ADD_APPOINTMENT_LOCATION_TYPE_ERROR,
    payload: error,
  }
}


export const getAppLocationType = (agentId) => ({
  type: GET_APPOINTMENT_LOCATION_TYPE,
  agentId
})

export const getAppLocationTypeSuccess = locationTypes => ({
  type: GET_APPOINTMENT_LOCATION_TYPE_SUCCESS,
  payload: locationTypes,
})

export const getAppLocationTypeFail = error => ({
  type: GET_APPOINTMENT_LOCATION_TYPE_FAIL,
  payload: error,
})


export const updateAppLocationType = location => (
  {

    type: UPDATE_APPOINTMENT_LOCATION_TYPE,
    payload: location,
  })

export const updateAppLocationTypeSuccess = location => ({
  type: UPDATE_APPOINTMENT_LOCATION_TYPE_SUCCESS,
  payload: location,
})

export const updateAppLocationTypeFail = error => ({
  type: UPDATE_APPOINTMENT_LOCATION_TYPE_FAIL,
  payload: error,
})


export const deleteAppLocationType = id => ({
  type: DELETE_APPOINTMENT_LOCATION_TYPE,
  payload: id,
})

export const deleteAppLocationTypeSuccess = location => ({
  type: DELETE_APPOINTMENT_LOCATION_TYPE_SUCCESS,
  payload: location,
})

export const deleteAppLocationTypeFail = error => ({
  type: DELETE_APPOINTMENT_LOCATION_TYPE_ERROR,
  payload: error,
})

//APPOINTMENT PRIORITY

export const addAppointmentPriority = (priority, history) => {
  return {
    type: ADD_APPOINTMENT_PRIORITY,
    payload: { priority, history },
  }
}

export const addAppointmentPrioritySuccess = priority => {
  return {
    type: ADD_APPOINTMENT_PRIORITY_SUCCESS,
    payload: priority,
  }
}


export const addAppointmentPriorityError = error => {
  return {
    type: ADD_APPOINTMENT_PRIORITY_ERROR,
    payload: error,
  }
}


export const getAppointmentPriority = (agentId) => ({
  type: GET_APPOINTMENT_PRIORITY,
  agentId
})

export const getAppointmentPrioritySuccess = priorities => ({
  type: GET_APPOINTMENT_PRIORITY_SUCCESS,
  payload: priorities,
})

export const getAppointmentPriorityFail = error => ({
  type: GET_APPOINTMENT_PRIORITY_FAIL,
  payload: error,
})


export const updateAppointmentPriority = priority => (
  {

    type: UPDATE_APPOINTMENT_PRIORITY,
    payload: priority,
  })

export const updateAppointmentPrioritySuccess = priority => ({
  type: UPDATE_APPOINTMENT_PRIORITY_SUCCESS,
  payload: priority,
})

export const updateAppointmentPriorityFail = error => ({
  type: UPDATE_APPOINTMENT_PRIORITY_FAIL,
  payload: error,
})


export const deleteAppointmentPriority = id => ({
  type: DELETE_APPOINTMENT_PRIORITY,
  payload: id,
})

export const deleteAppointmentPrioritySuccess = priority => ({
  type: DELETE_APPOINTMENT_PRIORITY_SUCCESS,
  payload: priority,
})

export const deleteAppointmentPriorityFail = error => ({
  type: DELETE_APPOINTMENT_PRIORITY_ERROR,
  payload: error,
})


////APPOINTMENT TYPE


export const addAppointmentType = (type, history) => {
  return {
    type: ADD_APPOINTMENT_TYPE,
    payload: { type, history },
  }
}

export const addAppointmentTypeSuccess = type => {
  return {
    type: ADD_APPOINTMENT_TYPE_SUCCESS,
    payload: type,
  }
}


export const addAppointmentTypeError = error => {
  return {
    type: ADD_APPOINTMENT_TYPE_ERROR,
    payload: error,
  }
}


export const getAppointmentType = (agentId) => ({
  type: GET_APPOINTMENT_TYPE,
  agentId
})

export const getAppointmentTypeSuccess = types => ({
  type: GET_APPOINTMENT_TYPE_SUCCESS,
  payload: types,
})

export const getAppointmentTypeFail = error => ({
  type: GET_APPOINTMENT_TYPE_FAIL,
  payload: error,
})


export const updateAppointmentType = type => (
  {

    type: UPDATE_APPOINTMENT_TYPE,
    payload: type,
  })

export const updateAppointmentTypeSuccess = type => ({
  type: UPDATE_APPOINTMENT_TYPE_SUCCESS,
  payload: priority,
})

export const updateAppointmentTypeFail = error => ({
  type: UPDATE_APPOINTMENT_TYPE_FAIL,
  payload: error,
})


export const deleteAppointmentType = id => ({
  type: DELETE_APPOINTMENT_TYPE,
  payload: id,
})

export const deleteAppointmentTypeSuccess = type => ({
  type: DELETE_APPOINTMENT_TYPE_SUCCESS,
  payload: type,
})

export const deleteAppointmentTypeFail = error => ({
  type: DELETE_APPOINTMENT_TYPE_ERROR,
  payload: error,
})


// Contact Level


export const addContactLevel = (level, history) => {
  return {
    type: ADD_CONTACT_LEVEL,
    payload: { level, history },
  }
}

export const addContactLevelSuccess = level => {
  return {
    type: ADD_CONTACT_LEVEL_SUCCESS,
    payload: level,
  }
}


export const addContactLevelError = error => {
  return {
    type: ADD_CONTACT_LEVEL_ERROR,
    payload: error,
  }
}


export const getContactLevel = (agentId) => ({
  type: GET_CONTACT_LEVEL,
  agentId
})

export const getContactLevelSuccess = levels => ({
  type: GET_CONTACT_LEVEL_SUCCESS,
  payload: levels,
})

export const getContactLevelFail = error => ({
  type: GET_CONTACT_LEVEL_FAIL,
  payload: error,
})


export const updateContactLevel = level => (
  {

    type: UPDATE_CONTACT_LEVEL,
    payload: level,
  })

export const updateContactLevelSuccess = level => ({
  type: UPDATE_CONTACT_LEVEL_SUCCESS,
  payload: level,
})

export const updateContactLevelFail = error => ({
  type: UPDATE_CONTACT_LEVEL_FAIL,
  payload: error,
})


export const deleteContactLevel = id => ({
  type: DELETE_CONTACT_LEVEL,
  payload: id,
})

export const deleteContactLevelSuccess = level => ({
  type: DELETE_CONTACT_LEVEL_SUCCESS,
  payload: level,
})

export const deleteContactLevelFail = error => ({
  type: DELETE_CONTACT_LEVEL_ERROR,
  payload: error,
})


//Contact Status


export const addContactStatus = (status, history) => {
  return {
    type: ADD_CONTACT_STATUS,
    payload: { status, history },
  }
}

export const addContactStatusSuccess = status => {
  return {
    type: ADD_CONTACT_STATUS_SUCCESS,
    payload: status,
  }
}


export const addContactStatusError = error => {
  return {
    type: ADD_CONTACT_STATUS_ERROR,
    payload: error,
  }
}


export const getContactStatus = (agentId) => ({
  type: GET_CONTACT_STATUS,
  agentId
})

export const getContactStatusSuccess = statuses => ({
  type: GET_CONTACT_STATUS_SUCCESS,
  payload: statuses,
})

export const getContactStatusFail = error => ({
  type: GET_CONTACT_STATUS_FAIL,
  payload: error,
})


export const updateContactStatus = status => (
  {

    type: UPDATE_CONTACT_STATUS,
    payload: status,
  })

export const updateContactStatusSuccess = status => ({
  type: UPDATE_CONTACT_STATUS_SUCCESS,
  payload: status,
})

export const updateContactStatusFail = error => ({
  type: UPDATE_CONTACT_STATUS_FAIL,
  payload: error,
})


export const deleteContactStatus = id => ({
  type: DELETE_CONTACT_STATUS,
  payload: id,
})

export const deleteContactStatusSuccess = status => ({
  type: DELETE_CONTACT_STATUS_SUCCESS,
  payload: status,
})

export const deleteContactStatusFail = error => ({
  type: DELETE_CONTACT_STATUS_ERROR,
  payload: error,
})



export const addContactType = (contacttype, history) => {
  return {
    type: ADD_CONTACT_TYPE,
    payload: { contacttype, history },
  }
}

export const addContactTypeSuccess = contacttype => {
  return {
    type: ADD_CONTACT_TYPE_SUCCESS,
    payload: contacttype,
  }
}


export const addContactTypeError = error => {
  return {
    type: ADD_CONTACT_TYPE_ERROR,
    payload: error,
  }
}


export const getContactType = (agentId) => ({
  type: GET_CONTACT_TYPE,
  agentId
})

export const getContactTypeSuccess = contacttypes => ({
  type: GET_CONTACT_TYPE_SUCCESS,
  payload: contacttypes,
})

export const getContactTypeFail = error => ({
  type: GET_CONTACT_TYPE_FAIL,
  payload: error,
})


export const updateContactType = contacttype => (
  {

    type: UPDATE_CONTACT_TYPE,
    payload: contacttype,
  })

export const updateContactTypeSuccess = contacttype => ({
  type: UPDATE_CONTACT_TYPE_SUCCESS,
  payload: contacttype,
})

export const updateContactTypeFail = error => ({
  type: UPDATE_CONTACT_TYPE_FAIL,
  payload: error,
})


export const deleteContactType = id => ({
  type: DELETE_CONTACT_TYPE,
  payload: id,
})

export const deleteContactTypeSuccess = contacttype => ({
  type: DELETE_CONTACT_TYPE_SUCCESS,
  payload: contacttype,
})

export const deleteContactTypeFail = error => ({
  type: DELETE_CONTACT_TYPE_ERROR,
  payload: error,
})



export const addLeadClassification = (leadclass, history) => {
  return {
    type: ADD_LEAD_CLASSIFICATION,
    payload: { leadclass, history },
  }
}

export const addLeadClassificationSuccess = leadclass => {
  return {
    type: ADD_LEAD_CLASSIFICATION_SUCCESS,
    payload: leadclass,
  }
}


export const addLeadClassificationError = error => {
  return {
    type: ADD_LEAD_CLASSIFICATION_ERROR,
    payload: error,
  }
}


export const getLeadClassification = (agentId) => ({
  type: GET_LEAD_CLASSIFICATION,
  agentId
})

export const getLeadClassificationSuccess = leadclasses => ({
  type: GET_LEAD_CLASSIFICATION_SUCCESS,
  payload: leadclasses,
})

export const getLeadClassificationFail = error => ({
  type: GET_LEAD_CLASSIFICATION_FAIL,
  payload: error,
})


export const updateLeadClassfication = leadclass => (
  {

    type: UPDATE_LEAD_CLASSIFICATION,
    payload: leadclass,
  })

export const updateLeadClassficationSuccess = leadclass => ({
  type: UPDATE_LEAD_CLASSIFICATION_SUCCESS,
  payload: leadclass,
})

export const updateLeadClassficationFail = error => ({
  type: UPDATE_LEAD_CLASSIFICATION_FAIL,
  payload: error,
})


export const deleteLeadClassification = id => ({
  type: DELETE_LEAD_CLASSIFICATION,
  payload: id,
})

export const deleteLeadClassificationSuccess = leadclass => ({
  type: DELETE_LEAD_CLASSIFICATION_SUCCESS,
  payload: leadclass,
})

export const deleteLeadClassificationFail = error => ({
  type: DELETE_LEAD_CLASSIFICATION_ERROR,
  payload: error,
})


export const addLeadSource = (leadsource, history) => {
  return {
    type: ADD_LEAD_SOURCE,
    payload: { leadsource, history },
  }
}

export const addLeadSourceSuccess = leadsource => {
  return {
    type: ADD_LEAD_SOURCE_SUCCESS,
    payload: leadsource,
  }
}


export const addLeadSourceError = error => {
  return {
    type: ADD_LEAD_SOURCE_ERROR,
    payload: error,
  }
}


export const getLeadStage = (agentId) => ({
  type: GET_LEAD_STAGE,
  agentId
})

export const getLeadStageSuccess = leadstages => ({
  type: GET_LEAD_STAGE_SUCCESS,
  payload: leadstages,
})

export const getLeadStageFail = error => ({
  type: GET_LEAD_STAGE_FAIL,
  payload: error,
})


export const updateLeadStage = leadstage => (
  {

    type: UPDATE_LEAD_STAGE,
    payload: leadstage,
  })

export const updateLeadStageSuccess = leadstage => ({
  type: UPDATE_LEAD_STAGE_SUCCESS,
  payload: leadstage,
})

export const updateLeadStageFail = error => ({
  type: UPDATE_LEAD_STAGE_FAIL,
  payload: error,
})


export const deleteLeadStage = id => ({
  type: DELETE_LEAD_STAGE,
  payload: id,
})

export const deleteLeadStageSuccess = leadstage => ({
  type: DELETE_LEAD_STAGE_SUCCESS,
  payload: leadstage,
})

export const deleteLeadStageFail = error => ({
  type: DELETE_LEAD_STAGE_ERROR,
  payload: error,
})



export const addLeadStatus = (leadstatus, history) => {
  return {
    type: ADD_LEAD_STATUS,
    payload: { leadstatus, history },
  }
}

export const addLeadStatusSuccess = leadstatus => {
  return {
    type: ADD_LEAD_STATUS_SUCCESS,
    payload: leadstatus,
  }
}


export const addLeadStatusError = error => {
  return {
    type: ADD_LEAD_STATUS_ERROR,
    payload: error,
  }
}


export const getLeadStatus = (agentId) => ({
  type: GET_LEAD_STATUS,
  agentId
})

export const getLeadStatusSuccess = leadstatuses => ({
  type: GET_LEAD_STATUS_SUCCESS,
  payload: leadstatuses,
})

export const getLeadStatusFail = error => ({
  type: GET_LEAD_STATUS_FAIL,
  payload: error,
})


export const updateLeadStatus = leadstatus => (
  {

    type: UPDATE_LEAD_STATUS,
    payload: leadstatus,
  })

export const updateLeadStatusSuccess = leadstatus => ({
  type: UPDATE_LEAD_STATUS_SUCCESS,
  payload: leadstatus,
})

export const updateLeadStatusFail = error => ({
  type: UPDATE_LEAD_STATUS_FAIL,
  payload: error,
})


export const deleteLeadStatus = id => ({
  type: DELETE_LEAD_STATUS,
  payload: id,
})

export const deleteLeadStatusSuccess = leadstatus => ({
  type: DELETE_LEAD_STATUS_SUCCESS,
  payload: status,
})

export const deleteLeadStatusFail = error => ({
  type: DELETE_LEAD_STATUS_ERROR,
  payload: error,
})




export const addLeadType = (leadtype, history) => {
  return {
    type: ADD_LEAD_TYPE,
    payload: { leadtype, history },
  }
}

export const addLeadTypeSuccess = leadtype => {
  return {
    type: ADD_LEAD_TYPE_SUCCESS,
    payload: leadtype,
  }
}


export const addLeadTypeError = error => {
  return {
    type: ADD_LEAD_TYPE_ERROR,
    payload: error,
  }
}


export const getLeadType = (agentId) => ({
  type: GET_LEAD_TYPE,
  agentId
})

export const getLeadTypeSuccess = leadtypes => ({
  type: GET_LEAD_TYPE_SUCCESS,
  payload: leadtypes,
})

export const getLeadTypeFail = error => ({
  type: GET_LEAD_TYPE_FAIL,
  payload: error,
})


export const updateLeadType = leadtype => (
  {

    type: UPDATE_LEAD_TYPE,
    payload: leadtype,
  })

export const updateLeadTypeSuccess = leadtype => ({
  type: UPDATE_LEAD_TYPE_SUCCESS,
  payload: leadtype,
})

export const updateLeadTypeFail = error => ({
  type: UPDATE_LEAD_TYPE_FAIL,
  payload: error,
})


export const deleteLeadType = id => ({
  type: DELETE_LEAD_TYPE,
  payload: id,
})

export const deleteLeadTypeSuccess = leadtype => ({
  type: DELETE_LEAD_TYPE_SUCCESS,
  payload: leadtype,
})

export const deleteLeadTypeFail = error => ({
  type: DELETE_LEAD_TYPE_ERROR,
  payload: error,
})





export const addNoteType = (notetype, history) => {
  return {
    type: ADD_NOTE_TYPE,
    payload: { notetype, history },
  }
}

export const addNoteTypeSuccess = notetype => {
  return {
    type: ADD_NOTE_TYPE_SUCCESS,
    payload: notetype,
  }
}


export const addNoteTypeError = error => {
  return {
    type: ADD_NOTE_TYPE_ERROR,
    payload: error,
  }
}


export const getNoteType = (agentId) => ({
  type: GET_NOTE_TYPE,
  agentId
})

export const getNoteTypeSuccess = notetypes => ({
  type: GET_NOTE_TYPE_SUCCESS,
  payload: notetypes,
})

export const getNoteTypeFail = error => ({
  type: GET_NOTE_TYPE_FAIL,
  payload: error,
})


export const updateNoteType = notetype => (
  {

    type: UPDATE_NOTE_TYPE,
    payload: notetype,
  })

export const updateNoteTypeSuccess = notetype => ({
  type: UPDATE_NOTE_TYPE_SUCCESS,
  payload: notetype,
})

export const updateNoteTypeFail = error => ({
  type: UPDATE_NOTE_TYPE_FAIL,
  payload: error,
})


export const deleteNoteType = id => ({
  type: DELETE_NOTE_TYPE,
  payload: id,
})

export const deleteNoteTypeSuccess = notetype => ({
  type: DELETE_NOTE_TYPE_SUCCESS,
  payload: notetype,
})

export const deleteNoteTypeFail = error => ({
  type: DELETE_NOTE_TYPE_ERROR,
  payload: error,
})

//
export const addProjectDocType = (doctype, history) => {
  return {
    type: ADD_PROJECT_DOCUMENT_TYPE,
    payload: { doctype, history },
  }
}

export const addProjectDocTypeSuccess = doctype => {
  return {
    type: ADD_PROJECT_DOCUMENT_TYPE_SUCCESS,
    payload: doctype,
  }
}


export const addProjectDocTypeError = error => {
  return {
    type: ADD_PROJECT_DOCUMENT_TYPE_ERROR,
    payload: error,
  }
}


export const getProjectDocType = (agentId) => ({
  type: GET_PROJECT_DOCUMENT_TYPE,
  agentId
})

export const getProjectDocTypeSuccess = doctypes => ({
  type: GET_PROJECT_DOCUMENT_TYPE_SUCCESS,
  payload: doctypes,
})

export const getProjectDocTypeFail = error => ({
  type: GET_PROJECT_DOCUMENT_TYPE_FAIL,
  payload: error,
})


export const updateProjectDocType = doctype => (
  {

    type: UPDATE_PROJECT_DOCUMENT_TYPE,
    payload: doctype,
  })

export const updateProjectDocTypeSuccess = doctype => ({
  type: UPDATE_PROJECT_DOCUMENT_TYPE_SUCCESS,
  payload: doctype,
})

export const updateProjectDocTypeFail = error => ({
  type: UPDATE_PROJECT_DOCUMENT_TYPE_FAIL,
  payload: error,
})


export const deleteProjectDocType = id => ({
  type: DELETE_PROJECT_DOCUMENT_TYPE,
  payload: id,
})

export const deleteProjectDocTypeSuccess = doctype => ({
  type: DELETE_PROJECT_DOCUMENT_TYPE_SUCCESS,
  payload: doctype,
})

export const deleteProjectDocTypeFail = error => ({
  type: DELETE_PROJECT_DOCUMENT_TYPE_ERROR,
  payload: error,
})


//
export const addProjectStatus = (docstatus, history) => {
  return {
    type: ADD_PROJECT_STATUS,
    payload: { docstatus, history },
  }
}

export const addProjectStatusSuccess = docstatus => {
  return {
    type: ADD_PROJECT_STATUS_SUCCESS,
    payload: docstatus,
  }
}


export const addProjectStatusError = error => {
  return {
    type: ADD_PROJECT_STATUS_ERROR,
    payload: error,
  }
}


export const getProjectStatus = (agentId) => ({
  type: GET_PROJECT_STATUS,
  agentId
})

export const getProjectStatusSuccess = docstatuses => ({
  type: GET_PROJECT_STATUS_SUCCESS,
  payload: docstatuses,
})

export const getProjectStatusFail = error => ({
  type: GET_PROJECT_STATUS_FAIL,
  payload: error,
})


export const updateProjectStatus = docstatus => (
  {

    type: UPDATE_PROJECT_STATUS,
    payload: docstatus,
  })

export const updateProjectStatusSuccess = docstatus => ({
  type: UPDATE_PROJECT_STATUS_SUCCESS,
  payload: docstatus,
})

export const updateProjectStatusFail = error => ({
  type: UPDATE_PROJECT_STATUS_FAIL,
  payload: error,
})


export const deleteProjectStatus = id => ({
  type: DELETE_PROJECT_STATUS,
  payload: id,
})

export const deleteProjectStatusSuccess = docstatus => ({
  type: DELETE_PROJECT_STATUS_SUCCESS,
  payload: docstatus,
})

export const deleteProjectStatusFail = error => ({
  type: DELETE_PROJECT_STATUS_ERROR,
  payload: error,
})

//
export const addProjectType = (protype, history) => {
  return {
    type: ADD_PROJECT_TYPE,
    payload: { protype, history },
  }
}

export const addProjectTypeSuccess = protype => {
  return {
    type: ADD_PROJECT_TYPE_SUCCESS,
    payload: protype,
  }
}


export const addProjectTypeError = error => {
  return {
    type: ADD_PROJECT_TYPE_ERROR,
    payload: error,
  }
}


export const getProjectType = (agentId) => ({
  type: GET_PROJECT_TYPE,
  agentId
})

export const getProjectTypeSuccess = protypes => ({
  type: GET_PROJECT_TYPE_SUCCESS,
  payload: protypes,
})

export const getProjectTypeFail = error => ({
  type: GET_PROJECT_TYPE_FAIL,
  payload: error,
})


export const updateProjectType = protype => (
  {

    type: UPDATE_PROJECT_TYPE,
    payload: protype,
  })

export const updateProjectTypeSuccess = protype => ({
  type: UPDATE_PROJECT_TYPE_SUCCESS,
  payload: protype,
})

export const updateProjectTypeFail = error => ({
  type: UPDATE_PROJECT_TYPE_FAIL,
  payload: error,
})


export const deleteProjectType = id => ({
  type: DELETE_PROJECT_TYPE,
  payload: id,
})

export const deleteProjectTypeSuccess = protype => ({
  type: DELETE_PROJECT_TYPE_SUCCESS,
  payload: protype,
})

export const deleteProjectTypeFail = error => ({
  type: DELETE_PROJECT_TYPE_ERROR,
  payload: error,
})

//
export const addServiceType = (sertype, history) => {
  return {
    type: ADD_SERVICE_TYPE,
    payload: { sertype, history },
  }
}

export const addServiceTypeSuccess = sertype => {
  return {
    type: ADD_SERVICE_TYPE_SUCCESS,
    payload: sertype,
  }
}


export const addServiceTypeError = error => {
  return {
    type: ADD_SERVICE_TYPE_ERROR,
    payload: error,
  }
}


export const getServiceType = (agentId) => ({
  type: GET_SERVICE_TYPE,
  agentId
})

export const getServiceTypeSuccess = sertypes => ({
  type: GET_SERVICE_TYPE_SUCCESS,
  payload: sertypes,
})

export const getServiceTypeFail = error => ({
  type: GET_SERVICE_TYPE_FAIL,
  payload: error,
})


export const updateServiceType = sertype => (
  {

    type: UPDATE_SERVICE_TYPE,
    payload: sertype,
  })

export const updateServiceTypeSuccess = sertype => ({
  type: UPDATE_SERVICE_TYPE_SUCCESS,
  payload: sertype,
})

export const updateServiceTypeFail = error => ({
  type: UPDATE_SERVICE_TYPE_FAIL,
  payload: error,
})


export const deleteServiceType = id => ({
  type: DELETE_SERVICE_TYPE,
  payload: id,
})

export const deleteServiceTypeSuccess = sertype => ({
  type: DELETE_SERVICE_TYPE_SUCCESS,
  payload: sertype,
})

export const deleteServiceTypeFail = error => ({
  type: DELETE_SERVICE_TYPE_ERROR,
  payload: error,
})

//
export const addTaskPriority = (taskpriority, history) => {
  return {
    type: ADD_TASK_PRIORITY,
    payload: { taskpriority, history },
  }
}

export const addTaskPrioritySuccess = taskpriority => {
  return {
    type: ADD_TASK_PRIORITY_SUCCESS,
    payload: taskpriority,
  }
}


export const addTaskPriorityError = error => {
  return {
    type: ADD_TASK_PRIORITY_ERROR,
    payload: error,
  }
}


export const getTaskPriority = (agentId) => ({
  type: GET_TASK_PRIORITY,
  agentId
})

export const getTaskPrioritySuccess = taskpriorities => ({
  type: GET_TASK_PRIORITY_SUCCESS,
  payload: taskpriorities,
})

export const getTaskPriorityFail = error => ({
  type: GET_TASK_PRIORITY_FAIL,
  payload: error,
})


export const updateTaskPriority = taskpriority => (
  {

    type: UPDATE_TASK_PRIORITY,
    payload: taskpriority,
  })

export const updateTaskPrioritySuccess = taskpriority => ({
  type: UPDATE_TASK_PRIORITY_SUCCESS,
  payload: taskpriority,
})

export const updateTaskPriorityFail = error => ({
  type: UPDATE_TASK_PRIORITY_FAIL,
  payload: error,
})


export const deleteTaskPriority = id => ({
  type: DELETE_TASK_PRIORITY,
  payload: id,
})

export const deleteTaskPrioritySuccess = taskpriority => ({
  type: DELETE_TASK_PRIORITY_SUCCESS,
  payload: taskpriority,
})

export const deleteTaskPriorityFail = error => ({
  type: DELETE_TASK_PRIORITY_ERROR,
  payload: error,
})


//
export const addTaskReminder = (taskreminder, history) => {
  return {
    type: ADD_TASK_REMINDER,
    payload: { taskreminder, history },
  }
}

export const addTaskReminderSuccess = taskreminder => {
  return {
    type: ADD_TASK_REMINDER_SUCCESS,
    payload: taskreminder,
  }
}


export const addTaskReminderError = error => {
  return {
    type: ADD_TASK_REMINDER_ERROR,
    payload: error,
  }
}


export const getTaskReminder = (agentId) => ({
  type: GET_TASK_REMINDER,
  agentId
})

export const getTaskReminderSuccess = taskreminders => ({
  type: GET_TASK_REMINDER_SUCCESS,
  payload: taskreminders,
})

export const getTaskReminderFail = error => ({
  type: GET_TASK_REMINDER_FAIL,
  payload: error,
})


export const updateTaskReminder = taskreminder => (
  {

    type: UPDATE_TASK_REMINDER,
    payload: taskreminder,
  })

export const updateTaskReminderSuccess = taskreminder => ({
  type: UPDATE_TASK_REMINDER_SUCCESS,
  payload: taskreminder,
})

export const updateTaskReminderFail = error => ({
  type: UPDATE_TASK_REMINDER_FAIL,
  payload: error,
})


export const deleteTaskReminder = id => ({
  type: DELETE_TASK_REMINDER,
  payload: id,
})

export const deleteTaskReminderSuccess = taskreminder => ({
  type: DELETE_TASK_REMINDER_SUCCESS,
  payload: taskreminder,
})

export const deleteTaskReminderFail = error => ({
  type: DELETE_TASK_REMINDER_ERROR,
  payload: error,
})

//
export const addTaskStatus = (taskstatus, history) => {
  return {
    type: ADD_TASK_STATUS,
    payload: { taskstatus, history },
  }
}

export const addTaskStatusSuccess = taskstatus => {
  return {
    type: ADD_TASK_STATUS_SUCCESS,
    payload: taskstatus,
  }
}


export const addTaskStatusError = error => {
  return {
    type: ADD_TASK_STATUS_ERROR,
    payload: error,
  }
}


export const getTaskStatus = (agentId) => ({
  type: GET_TASK_STATUS,
  agentId
})

export const getTaskStatusSuccess = taskstatuses => ({
  type: GET_TASK_STATUS_SUCCESS,
  payload: taskstatuses,
})

export const getTaskStatusFail = error => ({
  type: GET_TASK_STATUS_FAIL,
  payload: error,
})


export const updateTaskStatus = taskstatus => (
  {

    type: UPDATE_TASK_STATUS,
    payload: taskstatus,
  })

export const updateTaskStatusSuccess = taskstatus => ({
  type: UPDATE_TASK_STATUS_SUCCESS,
  payload: taskstatus,
})

export const updateTaskStatusFail = error => ({
  type: UPDATE_TASK_STATUS_FAIL,
  payload: error,
})


export const deleteTaskStatus = id => ({
  type: DELETE_TASK_STATUS,
  payload: id,
})

export const deleteTaskStatusSuccess = taskstatus => ({
  type: DELETE_TASK_STATUS_SUCCESS,
  payload: taskstatus,
})

export const deleteTaskStatusFail = error => ({
  type: DELETE_TASK_STATUS_ERROR,
  payload: error,
})


//
export const addTaskType = (tasktype, history) => {
  return {
    type: ADD_TASK_TYPE,
    payload: { tasktype, history },
  }
}

export const addTaskTypeSuccess = tasktype => {
  return {
    type: ADD_TASK_TYPE_SUCCESS,
    payload: tasktype,
  }
}


export const addTaskTypeError = error => {
  return {
    type: ADD_TASK_TYPE_ERROR,
    payload: error,
  }
}


export const getTaskType = (agentId) => ({
  type: GET_TASK_TYPE,
  agentId
})

export const getTaskTypeSuccess = taskstypes => ({
  type: GET_TASK_TYPE_SUCCESS,
  payload: taskstypes,
})

export const getTaskTypeFail = error => ({
  type: GET_TASK_TYPE_FAIL,
  payload: error,
})


export const updateTaskType = tasktype => (
  {

    type: UPDATE_TASK_TYPE,
    payload: tasktype,
  })

export const updateTaskTypeSuccess = tasktype => ({
  type: UPDATE_TASK_TYPE_SUCCESS,
  payload: tasktype,
})

export const updateTaskTypeFail = error => ({
  type: UPDATE_TASK_TYPE_FAIL,
  payload: error,
})


export const deleteTaskType = id => ({
  type: DELETE_TASK_TYPE,
  payload: id,
})

export const deleteTaskTypeSuccess = tasktype => ({
  type: DELETE_TASK_TYPE_SUCCESS,
  payload: tasktype,
})

export const deleteTaskTypeFail = error => ({
  type: DELETE_TASK_TYPE_ERROR,
  payload: error,
})


export const addLeadStage = (leadstage, history) => {
  return {
    type: ADD_LEAD_STAGE,
    payload: { leadstage, history },
  }
}

export const addLeadStageSuccess = leadstage => {
  return {
    type: ADD_LEAD_STAGE_SUCCESS,
    payload: leadstage,
  }
}


export const addLeadStageError = error => {
  return {
    type: ADD_LEAD_STAGE_ERROR,
    payload: error,
  }
}


export const getLeadSource = (agentId) => ({
  type: GET_LEAD_SOURCE,
  agentId
})

export const getLeadSourceSuccess = leadsources => ({
  type: GET_LEAD_SOURCE_SUCCESS,
  payload: leadsources,
})

export const getLeadSourceFail = error => ({
  type: GET_LEAD_SOURCE_FAIL,
  payload: error,
})


export const updateLeadSource = leadsource => (
  {

    type: UPDATE_LEAD_SOURCE,
    payload: leadsource,
  })

export const updateLeadSourceSuccess = leadsource => ({
  type: UPDATE_LEAD_SOURCE_SUCCESS,
  payload: leadsource,
})

export const updateLeadSourceFail = error => ({
  type: UPDATE_LEAD_SOURCE_FAIL,
  payload: error,
})


export const deleteLeadSource = id => ({
  type: DELETE_LEAD_SOURCE,
  payload: id,
})

export const deleteLeadSourceSuccess = leadsource => ({
  type: DELETE_LEAD_SOURCE_SUCCESS,
  payload: leadsource,
})

export const deleteLeadSourceFail = error => ({
  type: DELETE_LEAD_SOURCE_ERROR,
  payload: error,
})

//Transaction Type
export const addTransType = (transactonType, history) => {
  return {
    type: ADD_TRANSACTION_TYPE,
    payload: { transactonType, history },
  }
}

export const addTransTypeSuccess = transactonType => {
  return {
    type: ADD_TRANSACTION_TYPE_SUCCESS,
    payload: transactonType,
  }
}


export const addTransTypeError = error => {
  return {
    type: ADD_TRANSACTION_TYPE_ERROR,
    payload: error,
  }
}


export const getTransType = (agentId) => ({
  type: GET_TRANSACTION_TYPE,
  agentId
})

export const getTransTypeSuccess = transactonTypes => ({
  type: GET_TRANSACTION_TYPE_SUCCESS,
  payload: transactonTypes,
})

export const getTransTypeFail = error => ({
  type: GET_TRANSACTION_TYPE_FAIL,
  payload: error,
})


export const updateTransType = transactonType => (
  {

    type: UPDATE_TRANSACTION_TYPE,
    payload: transactonType,
  })

export const updateTransTypeSuccess = transactonType => ({
  type: UPDATE_TRANSACTION_TYPE_SUCCESS,
  payload: transactonType,
})

export const updateTransTypeFail = error => ({
  type: UPDATE_TRANSACTION_TYPE_FAIL,
  payload: error,
})


export const deleteTransType = id => ({
  type: DELETE_TRANSACTION_TYPE,
  payload: id,
})

export const deleteTransTypeSuccess = transactonType => ({
  type: DELETE_TRANSACTION_TYPE_SUCCESS,
  payload: transactonType,
})

export const deleteTransTypeFail = error => ({
  type: DELETE_TRANSACTION_TYPE_ERROR,
  payload: error,
})


//Transaction Commission Type
export const addTransCommType = (commTransType, history) => {
  return {
    type: ADD_TRANSACTION_COMMISSION_TYPE,
    payload: { commTransType, history },
  }
}

export const addTransCommTypeSuccess = transactionCommType => {
  return {
    type: ADD_TRANSACTION_COMMISSION_TYPE_SUCCESS,
    payload: transactionCommType,
  }
}


export const addTransCommTypeError = error => {
  return {
    type: ADD_TRANSACTION_COMMISSION_TYPE_ERROR,
    payload: error,
  }
}


export const getTransCommType = (agentId) => ({
  type: GET_TRANSACTION_COMMISSION_TYPE,
  agentId
})

export const getTransCommTypeSuccess = transactionCommTypes => ({
  type: GET_TRANSACTION_COMMISSION_TYPE_SUCCESS,
  payload: transactionCommTypes,
})

export const getTransCommTypeFail = error => ({
  type: GET_TRANSACTION_COMMISSION_TYPE_FAIL,
  payload: error,
})


export const updateTransCommType = transactionCommType => (
  {
    type: UPDATE_TRANSACTION_COMMISSION_TYPE,
    payload: transactionCommType,
  })

export const updateTransCommTypeSuccess = transactionCommType => ({
  type: UPDATE_TRANSACTION_COMMISSION_TYPE_SUCCESS,
  payload: transactionCommType,
})

export const updateTransCommTypeFail = error => ({
  type: UPDATE_TRANSACTION_COMMISSION_TYPE_FAIL,
  payload: error,
})


export const deleteTransCommType = id => ({
  type: DELETE_TRANSACTION_COMMISSION_TYPE,
  payload: id,
})

export const deleteTransCommTypeSuccess = transactionCommType => ({
  type: DELETE_TRANSACTION_COMMISSION_TYPE_SUCCESS,
  payload: transactionCommType,
})

export const deleteTransCommTypeFail = error => ({
  type: DELETE_TRANSACTION_COMMISSION_TYPE_ERROR,
  payload: error,
})

//Transaction Ref Type
export const addTransRefType = (refTransType, history) => {
  return {
    type: ADD_TRANSACTION_REF_TYPE,
    payload: { refTransType, history },
  }
}

export const addTransRefTypeSuccess = transactonRefType => {
  return {
    type: ADD_TRANSACTION_REF_TYPE_SUCCESS,
    payload: transactonRefType,
  }
}


export const addTransRefTypeError = error => {
  return {
    type: ADD_TRANSACTION_REF_TYPE_ERROR,
    payload: error,
  }
}


export const getTransRefType = (agentId) => ({
  type: GET_TRANSACTION_REF_TYPE,
  agentId
})

export const getTransRefTypeSuccess = transactonRefTypes => ({
  type: GET_TRANSACTION_REF_TYPE_SUCCESS,
  payload: transactonRefTypes,
})

export const getTransRefTypeFail = error => ({
  type: GET_TRANSACTION_REF_TYPE_FAIL,
  payload: error,
})


export const updateTransRefType = transactonRefType => (
  {
    type: UPDATE_TRANSACTION_REF_TYPE,
    payload: transactonRefType,
  })

export const updateTransRefTypeSuccess = transactonRefType => ({
  type: UPDATE_TRANSACTION_REF_TYPE_SUCCESS,
  payload: transactonRefType,
})

export const updateTransRefTypeFail = error => ({
  type: UPDATE_TRANSACTION_REF_TYPE_FAIL,
  payload: error,
})


export const deleteTransRefType = id => ({
  type: DELETE_TRANSACTION_REF_TYPE,
  payload: id,
})

export const deleteTransRefTypeSuccess = transactonRefType => ({
  type: DELETE_TRANSACTION_REF_TYPE_SUCCESS,
  payload: transactonRefType,
})

export const deleteTransRefTypeFail = error => ({
  type: DELETE_TRANSACTION_REF_TYPE_ERROR,
  payload: error,
})

//Transaction Status Type
export const addTransStatusType = (transStatusType, history) => {
  return {
    type: ADD_TRANSACTION_STATUS_TYPE,
    payload: { transStatusType, history },
  }
}

export const addTransStatusTypeSuccess = transStatusType => {
  return {
    type: ADD_TRANSACTION_STATUS_TYPE_SUCCESS,
    payload: transStatusType,
  }
}


export const addTransStatusTypeError = error => {
  return {
    type: ADD_TRANSACTION_STATUS_TYPE_ERROR,
    payload: error,
  }
}


export const getTransStatusType = (agentId, forType) => ({
  type: GET_TRANSACTION_STATUS_TYPE,
  payload:{ agentId, forType }
})

export const getTransStatusTypeSuccess = transStatusTypes => ({
  type: GET_TRANSACTION_STATUS_TYPE_SUCCESS,
  payload: transStatusTypes,
})

export const getTransStatusTypeFail = error => ({
  type: GET_TRANSACTION_STATUS_TYPE_FAIL,
  payload: error,
})


export const updateTransStatusType = transStatusType => (
  {
    type: UPDATE_TRANSACTION_STATUS_TYPE,
    payload: transStatusType,
  })

export const updateTransStatusTypeSuccess = transStatusType => ({
  type: UPDATE_TRANSACTION_STATUS_TYPE_SUCCESS,
  payload: transStatusType,
})

export const updateTransStatusTypeFail = error => ({
  type: UPDATE_TRANSACTION_STATUS_TYPE_FAIL,
  payload: error,
})


export const deleteTransStatusType = id => ({
  type: DELETE_TRANSACTION_STATUS_TYPE,
  payload: id,
})

export const deleteTransStatusTypeSuccess = transStatusType => ({
  type: DELETE_TRANSACTION_STATUS_TYPE_SUCCESS,
  payload: transStatusType,
})

export const deleteTransStatusTypeFail = error => ({
  type: DELETE_TRANSACTION_STATUS_TYPE_ERROR,
  payload: error,
})


export const addListingType = (listingtype, history) => {
  return {
    type: ADD_LISTING_TYPE,
    payload: { listingtype, history },
  }
}

export const addListingTypeSuccess = listingtype => {
  return {
    type: ADD_LISTING_TYPE_SUCCESS,
    payload: listingtype,
  }
}


export const addListingTypeError = error => {
  return {
    type: ADD_LISTING_TYPE_ERROR,
    payload: error,
  }
}


export const getListingType = (agentId) => ({
  type: GET_LISTING_TYPE,
  agentId
})

export const getListingTypeSuccess = listingtypes => ({
  type: GET_LISTING_TYPE_SUCCESS,
  payload: listingtypes,
})

export const getListingTypeFail = error => ({
  type: GET_LISTING_TYPE_FAIL,
  payload: error,
})


export const updateListingType = listingtype => (
  {

    type: UPDATE_LISTING_TYPE,
    payload: listingtype,
  })

export const updateListingTypeSuccess = listingtype => ({
  type: UPDATE_LISTING_TYPE_SUCCESS,
  payload: listingtype,
})

export const updateListingTypeFail = error => ({
  type: UPDATE_LISTING_TYPE_FAIL,
  payload: error,
})


export const deleteListingType = id => ({
  type: DELETE_LISTING_TYPE,
  payload: id,
})

export const deleteListingTypeSuccess = listingtype => ({
  type: DELETE_LISTING_TYPE_SUCCESS,
  payload: listingtype,
})

export const deleteListingTypeFail = error => ({
  type: DELETE_LISTING_TYPE_ERROR,
  payload: error,
})


export const addListingStatus = (listingstatus, history) => {
  return {
    type: ADD_LISTING_STATUS,
    payload: { listingstatus, history },
  }
}

export const addListingStatusSuccess = listingstatus => {
  return {
    type: ADD_LISTING_STATUS_SUCCESS,
    payload: listingstatus,
  }
}


export const addListingStatusError = error => {
  return {
    type: ADD_LISTING_STATUS_ERROR,
    payload: error,
  }
}

export const getListingStatus = (agentId) => ({
  type: GET_LISTING_STATUS,
  agentId
})

export const getListingStatusSuccess = listingstatuses => ({
  type: GET_LISTING_STATUS_SUCCESS,
  payload: listingstatuses,
})

export const getListingStatusFail = error => ({
  type: GET_LISTING_STATUS_ERROR,
  payload: error,
})


export const updateListingStatus = listingstatus => (
  {

    type: UPDATE_LISTING_STATUS,
    payload: listingstatus,
  })

export const updateListingStatusSuccess = listingstatus => ({
  type: UPDATE_LISTING_STATUS_SUCCESS,
  payload: listingstatus,
})

export const updateListingStatusFail = error => ({
  type: UPDATE_LISTING_STATUS_ERROR,
  payload: error,
})


export const deleteListingStatus = id => ({
  type: DELETE_LISTING_STATUS,
  payload: id,
})

export const deleteListingStatusSuccess = listingstatus => ({
  type: DELETE_LISTING_STATUS_SUCCESS,
  payload: listingstatus,
})

export const deleteListingStatusFail = error => ({
  type: DELETE_LISTING_STATUS_ERROR,
  payload: error,
})


export const addShowingStatus = (showingstatus, history) => {
  return {
    type: ADD_SHOWING_STATUS,
    payload: { showingstatus, history },
  }
}

export const addShowingStatusSuccess = showingstatus => {
  return {
    type: ADD_SHOWING_STATUS_SUCCESS,
    payload: showingstatus,
  }
}


export const addShowingStatusError = error => {
  return {
    type: ADD_SHOWING_STATUS_ERROR,
    payload: error,
  }
}


export const getShowingStatus = (agentId) => ({
  type: GET_SHOWING_STATUS,
  agentId
})

export const getShowingStatusSuccess = showingstatuses => ({
  type: GET_SHOWING_STATUS_SUCCESS,
  payload: showingstatuses,
})

export const getShowingStatusFail = error => ({
  type: GET_SHOWING_STATUS_ERROR,
  payload: error,
})


export const updateShowingStatus = showingstatus => (
  {

    type: UPDATE_SHOWING_STATUS,
    payload: showingstatus,
  })

export const updateShowingStatusSuccess = showingstatus => ({
  type: UPDATE_SHOWING_STATUS_SUCCESS,
  payload: showingstatus,
})

export const updateShowingStatusFail = error => ({
  type: UPDATE_SHOWING_STATUS_ERROR,
  payload: error,
})


export const deleteShowingStatus = id => ({
  type: DELETE_SHOWING_STATUS,
  payload: id,
})

export const deleteShowingStatusSuccess = listingstatus => ({
  type: DELETE_SHOWING_STATUS_SUCCESS,
  payload: listingstatus,
})

export const deleteShowingStatusFail = error => ({
  type: DELETE_SHOWING_STATUS_ERROR,
  payload: error,
})


export const addEmailListType = emaillisttype => {
  return {
    type: ADD_EMAIL_LIST_TYPE,
    emaillisttype,
  }
}

export const addEmailListTypeSuccess = emaillisttype => {
  return {
    type: ADD_EMAIL_LIST_TYPE_SUCCESS,
    payload: emaillisttype,
  }
}


export const addEmailListTypeError = error => {
  return {
    type: ADD_EMAIL_LIST_TYPE_ERROR,
    payload: error,
  }
}


export const getEmailListType = (agentId) => ({
  type: GET_EMAIL_LIST_TYPE,
  agentId
})

export const getEmailListTypeSuccess = emaillisttypes => ({
  type: GET_EMAIL_LIST_TYPE_SUCCESS,
  payload: emaillisttypes,
})

export const getEmailListTypeFail = error => ({
  type: GET_EMAIL_LIST_TYPE_ERROR,
  payload: error,
})


export const updateEmailListType = emaillisttype => (
  {
    type: UPDATE_EMAIL_LIST_TYPE,
    payload: emaillisttype,
  })

export const updateEmailListTypeSuccess = emaillisttype => ({
  type: UPDATE_EMAIL_LIST_TYPE_SUCCESS,
  payload: emaillisttype,
})

export const updateEmailListTypeFail = error => ({
  type: UPDATE_EMAIL_LIST_TYPE_ERROR,
  payload: error,
})

export const deleteEmailListType = id => ({
  type: DELETE_EMAIL_LIST_TYPE,
  payload: id,
})

export const deleteEmailListTypeSuccess = emaillisttype => ({
  type: DELETE_EMAIL_LIST_TYPE_SUCCESS,
  payload: emaillisttype,
})

export const deleteEmailListTypeFail = error => ({
  type: DELETE_EMAIL_LIST_TYPE_ERROR,
  payload: error,
})


export const addEmailListTarget = emaillisttarget => {
  return {
    type: ADD_EMAIL_LIST_TARGET,
    emaillisttarget,
  }
}

export const addEmailListTargetSuccess = emaillisttarget => {
  return {
    type: ADD_EMAIL_LIST_TARGET_SUCCESS,
    payload: emaillisttarget,
  }
}


export const addEmailListTargetError = error => {
  return {
    type: ADD_EMAIL_LIST_TARGET_ERROR,
    payload: error,
  }
}


export const getEmailListTarget = (agentId) => ({
  type: GET_EMAIL_LIST_TARGET,
  agentId
})

export const getEmailListTargetSuccess = emaillisttargets => ({
  type: GET_EMAIL_LIST_TARGET_SUCCESS,
  payload: emaillisttargets,
})

export const getEmailListTargetFail = error => ({
  type: GET_EMAIL_LIST_TARGET_ERROR,
  payload: error,
})

export const updateEmailListTarget = emaillisttarget => (
  {
    type: UPDATE_EMAIL_LIST_TARGET,
    payload: emaillisttarget,
  })

export const updateEmailListTargetSuccess = emaillisttarget => ({
  type: UPDATE_EMAIL_LIST_TARGET_SUCCESS,
  payload: emaillisttarget,
})

export const updateEmailListTargetFail = error => ({
  type: UPDATE_EMAIL_LIST_TARGET_ERROR,
  payload: error,
})


export const deleteEmailListTarget = id => ({
  type: DELETE_EMAIL_LIST_TARGET,
  payload: id,
})

export const deleteEmailListTargetSuccess = emaillisttarget => ({
  type: DELETE_EMAIL_LIST_TARGET_SUCCESS,
  payload: emaillisttarget,
})

export const deleteEmailListTargetFail = error => ({
  type: DELETE_EMAIL_LIST_TARGET_ERROR,
  payload: error,
})


export const addCampaignEmailList = campaignemaillist => {
  return {
    type: ADD_CAMPAIGN_EMAIL_LIST,
    campaignemaillist,
  }
}

export const addCampaignEmailListSuccess = campaignemaillist => {
  return {
    type: ADD_CAMPAIGN_EMAIL_LIST_SUCCESS,
    payload: campaignemaillist,
  }
}


export const addCampaignEmailListError = error => {
  return {
    type: ADD_CAMPAIGN_EMAIL_LIST_ERROR,
    payload: error,
  }
}

export const getCampaignEmailList = (agentId) => ({
  type: GET_CAMPAIGN_EMAIL_LIST,
  agentId
})

export const getCampaignEmailListSuccess = campaignemaillists => ({
  type: GET_CAMPAIGN_EMAIL_LIST_SUCCESS,
  payload: campaignemaillists,
})

export const getCampaignEmailListError = error => ({
  type: GET_CAMPAIGN_EMAIL_LIST_ERROR,
  payload: error,
})


export const updateCampaignEmailList = campaignemaillist => (
  {
    type: UPDATE_CAMPAIGN_EMAIL_LIST,
    payload: campaignemaillist,
  })

export const updateCampaignEmailListSuccess = campaignemaillist => ({
  type: UPDATE_CAMPAIGN_EMAIL_LIST_SUCCESS,
  payload: campaignemaillist,
})

export const updateCampaignEmailListFail = error => ({
  type: UPDATE_CAMPAIGN_EMAIL_LIST_ERROR,
  payload: error,
})


export const deleteCampaignEmailList = id => ({
  type: DELETE_CAMPAIGN_EMAIL_LIST,
  payload: id,
})

export const deleteCampaignEmailListSuccess = campaignemaillist => ({
  type: DELETE_CAMPAIGN_EMAIL_LIST_SUCCESS,
  payload: campaignemaillist,
})

export const deleteCampaignEmailListFail = error => ({
  type: DELETE_CAMPAIGN_EMAIL_LIST_ERROR,
  payload: error,
})
